var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Input, ViewChild, Inject } from '@angular/core';
import * as _ from 'lodash';
import { ConditionItemModel } from '../condition/condition-item-model';
import { ConditionType } from '../condition/condition-type';
import { BitConditionModel } from '../condition/bit/bit-condition-model';
import { WordConditionModel } from '../condition/word/word-condition-model';
import { VariableValueType } from '../condition/comm/variable-value-type';
import { RelationType } from '../condition/comm/relation-type';
import { ConditionHelper } from '../condition/comm/condition-helper';
import { ConditionSettingModalComponent } from '../condition/condition-setting-modal.component';
import { VariableVersion } from '../../../core/variable/variable-version';
import { VARIABLE_SERVICE } from '../../../core/variable/variable.service';
import { ResizableElementSettingModal } from '../../base/resizable-element-setting-modal';
var ConditionalControlComponent = /** @class */ (function (_super) {
    __extends(ConditionalControlComponent, _super);
    function ConditionalControlComponent(injector, bitConditionTypeOptionService, comparatorTypeOptionService, relationTypeOptionService, variableService, modalService, logicTypeOptionService) {
        var _this = _super.call(this, injector, 'controlSetting') || this;
        _this.bitConditionTypeOptionService = bitConditionTypeOptionService;
        _this.comparatorTypeOptionService = comparatorTypeOptionService;
        _this.relationTypeOptionService = relationTypeOptionService;
        _this.variableService = variableService;
        _this.modalService = modalService;
        _this.logicTypeOptionService = logicTypeOptionService;
        _this.isControl = false;
        _this.conditionItems = [];
        _this.constValueType = VariableValueType.Constant;
        _this.getConditionType = ConditionHelper.getConditionType;
        _this.logicTypes = _this.logicTypeOptionService.getOptions();
        return _this;
    }
    ConditionalControlComponent.prototype.init = function (editedComponent) {
        var _this = this;
        _super.prototype.init.call(this, editedComponent);
        var model = editedComponent.model.data;
        this.configureId = editedComponent.configureId;
        this.conditionItems = [];
        _.each(model.controlItems, function (item) {
            if (!item.condition.variableName) {
                item.condition.variableName = ' ';
            }
            if (item.condition.variableVersion) {
                _this.initConditions(item);
            }
            else if (!_.isNil(item.condition.dataSourceCode)) {
                _this.variableService.getVariableName(item.condition.dataSourceCode, item.condition.variableName, item.condition.variableGroupName).subscribe(function (value) {
                    item.condition.variableName = value.name;
                    item.condition.variableVersion = VariableVersion.variableVersion;
                    delete item.condition.variableGroupName;
                    delete item.condition.dataSourceCode;
                    _this.initConditions(item);
                });
            }
        });
    };
    ConditionalControlComponent.prototype.initConditions = function (item) {
        this.conditionItems.push(_.cloneDeep(item));
        this.setConditionsType(this.conditionItems);
    };
    ConditionalControlComponent.prototype.save = function () {
        if (this.saveDisplayInfo()) {
            this.saveSizeInfo();
            this.saveLocationInfo();
            this.saveFixedPositionType();
            return true;
        }
        return false;
    };
    ConditionalControlComponent.prototype.checkVariablesName = function () {
        var _this = this;
        var result = true;
        _.each(this.conditionItems, function (item) {
            if (!item.condition.variableName
                || item.condition.variableName === ' ') {
                _this.selectedCondition = item;
                result = false;
            }
        });
        return result;
    };
    ConditionalControlComponent.prototype.saveDisplayInfo = function () {
        this.saving = true;
        this.currentDiagram.startTransaction('control settings');
        if (this.isControl) {
            if (this.conditionItems.length === 0) {
                this.message.warn(this.lc('NoneControl'), this.lc('Note'));
                return false;
            }
            if (!this.checkVariablesName()) {
                this.message.warn(this.lc('VariableNameEmpty'), this.lc('Note'));
                return false;
            }
        }
        this.saveComponentProperty('controlItems', this.conditionItems);
        this.currentDiagram.commitTransaction('control settings');
        return true;
    };
    ConditionalControlComponent.prototype.onAdd = function () {
        var newCondition = new ConditionItemModel(this.conditionItems.length, ConditionType.Bit, undefined, RelationType.And);
        this.showConditionModal(newCondition);
    };
    ConditionalControlComponent.prototype.onModify = function () {
        if (!this.selectedCondition) {
            return;
        }
        this.showConditionModal(this.selectedCondition);
    };
    ConditionalControlComponent.prototype.onDelete = function () {
        var _this = this;
        if (!this.selectedCondition) {
            return;
        }
        this.message.confirm(this.lc('SureToDelete'), this.l('AreYouSure'), function (isConfirmed) {
            if (isConfirmed) {
                var index_1 = _this.conditionItems.indexOf(_this.selectedCondition);
                _this.conditionItems = _this.conditionItems.filter(function (val, i) { return i !== index_1; });
                _this.selectedCondition = null;
                if (_this.conditionItems.length > 0) {
                    _this.conditionItems[0].relationType = RelationType.None;
                    for (var i = index_1; i < _this.conditionItems.length; i++) {
                        _this.conditionItems[i].index = _this.conditionItems[i].index - 1;
                    }
                }
            }
        });
    };
    ConditionalControlComponent.prototype.onRowDbSelect = function (data) {
        this.selectedCondition = data;
        this.showConditionModal(this.selectedCondition);
    };
    ConditionalControlComponent.prototype.setConditionsType = function (record) {
        _.forEach(this.conditionItems, function (item) {
            item = ConditionHelper.setPrototypeOf(item, ConditionItemModel.prototype);
            if (item.conditionType === ConditionType.Bit) {
                item.condition = ConditionHelper.setPrototypeOf(item.condition, BitConditionModel.prototype);
            }
            else if (item.conditionType === ConditionType.Word) {
                item.condition = ConditionHelper.setPrototypeOf(item.condition, WordConditionModel.prototype);
            }
        });
    };
    ConditionalControlComponent.prototype.setConditionItem = function (event) {
        if (!event) {
            return;
        }
        if (!event.condition) {
            return;
        }
        var items = this.conditionItems.slice();
        var index = items.indexOf(event);
        if (index === -1) {
            // add
            if (items.length === 0) {
                event.relationType = RelationType.None;
            }
            items.push(event);
        }
        else {
            // modify
            items[index] = event;
        }
        this.conditionItems = items;
        event = null;
    };
    ConditionalControlComponent.prototype.showConditionModal = function (item) {
        var _this = this;
        var modalRef = this.modalService.show(ConditionSettingModalComponent, {
            initialState: {
                configureId: this.configureId,
                conditionItem: item
            },
            backdrop: 'static',
            class: 'condition-setting-modal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.setConditionItem(item);
            }
            onClosedSub.unsubscribe();
        });
    };
    __decorate([
        ViewChild('dataTable', { static: true })
    ], ConditionalControlComponent.prototype, "dataTable", void 0);
    __decorate([
        ViewChild('paginator', { static: false })
    ], ConditionalControlComponent.prototype, "paginator", void 0);
    __decorate([
        Input()
    ], ConditionalControlComponent.prototype, "isControl", void 0);
    ConditionalControlComponent = __decorate([
        Component({
            selector: 'conditional-control',
            styles: [".element-setting-base{ .inline-label { margin: 10px 0px 0px 10px; display: inline-block; } .border-group { // border: 1px solid #ddd; padding: 5px; margin-bottom: 0px; } .inline-selector { display: inline-block; margin: 5px 0px; } .inline-variable { display: inline-block; margin: 5px 0px; } .inline-input { display: inline-block; margin: 5px 0px; }     } .date-time-setting-modal { .modal-content { width: 600px; } .cursor-pointer{ cursor: pointer; } .recode-input{ width: calc(100% - 70px); border: 1px solid #d7dbe5;   padding:  5px 10px; } textarea.noResize { resize: none; } } .toggleViewSettingModal { .modal-content { width: 600px; } } .textSettingModal { .modal-content { width: 600px; } } ",
                ".display-setting-base{ .position-and-rotate{ width: 100%; } .position,.rotate{ width: calc(50% - 5px); } .position .fe-modal-content,.rotate .fe-modal-content{ height: 90px; } .rotate .fe-modal-content{ position: relative; } .position{ float: left; } .rotate{ float: right; } .position .flexem-form-body{ height: 90px; } .width-and-height{ height: 30px; width: 100%; } .width-and-height>div{ width: 50%; display: inline-block; max-width: 137px; } .width-and-height:nth-child(1){ margin-bottom: 10px; } .inline-block{ display: inline-block; } span.inline-block{ width: 20px; } input.inline-block{ width: 80px; height: 30px; } .width-and-height:nth-child(2){ margin-bottom: 0; } .rotate-body{ width: 64px; height: 64px; margin: 2px 10px;   position: relative; top: -5px;  } .rotate-border{ width: 54px; height: 54px; position: absolute; border: 1px solid #b5c2ca; top: 11px; left: 5px; } .rotate-top,.rotate-middle,.rotate-bottom{ width: 100%; height: 10px; display: flex; justify-content: space-between; align-items: center; } .rotate-middle,.rotate-bottom{ margin-top:16px;  } .rotate-top>div,.rotate-middle>div,.rotate-bottom>div{ width: 10px; height: 10px; } .rotate-body{ height: 66px; } .rotate-body input[type=radio]{ width: 10px; height: 10px; position: relative; } .rotate-body input[type=radio]::before{ width: 10px; height: 10px; background: white; border: 1px solid #b5c2ca; border-radius: 0; position: absolute; left: 0; top:0; } .rotate-body input[type=radio]::after{ top: 1px; left: 1px; } .rotate-body input[type=radio]:checked:before{ width: 10px; height: 10px; background: #3695ff; } .rotate-body input[type=radio]:checked:after{ top: 1px; left: 1px; } .angle{ width:130px; position: absolute; right: 10px; bottom: 10px; } .angle span{ width: 45px; line-height: 30px; font-size: 14px; } .angle input{ width: 80px; height: 30px; padding: 5px 10px; } .flexem-form-body{ position: relative; input{ padding: 0 5px; } } .primeng-datatable-container{ .ui-table-thead{ tr{ border-bottom: 0!important; } } th,td{ box-sizing: border-box; background: transparent; padding: 0 10px!important; line-height: 29px; } } .primeng-datatable-container .primeng-no-data{ box-sizing: border-box; padding: 5px 10px; height: 30px; } .ui-table-scrollable-body{ margin-top: -1px; } .btns button{ margin-right: 10px; } .btns{ margin: 10px 0;  } .margin-top-5{ margin-top: 5px; } .and-or-select{ font-size: 12px; color: #666666; height: 24px; width: 80px; } } "],
            template: "<div class=\"align-items-center fe-form element-setting-base display-setting-base\"> <div class=\"primeng-datatable-container\"> <p-table #dataTable [value]=\"conditionItems\" scrollable=\"true\" scrollHeight=\"100px\" ScrollWidth=\"100%\" selectionMode=\"single\" [(selection)]=\"selectedCondition\" [responsive]=\"true\" [style]=\"{'Height':'110px'}\"> <ng-template pTemplate=\"header\"> <tr> <th style=\"width:105px\">{{lc('Logic')}}</th> <th>{{lc('Condition')}}</th> </tr> </ng-template> <ng-template pTemplate=\"body\" let-rowData let-record=\"$implicit\"> <tr [pSelectableRow]=\"rowData\" (dblclick)=\"onRowDbSelect(record)\" class=\"cursor-pointer\"> <td style=\"width: 105px\"> <div *ngIf=\"record.relationType==1 || record.relationType==2\"> <select class=\"form-control inline-selector fc-Form\" style=\"height:25px;margin:0px\" name=\"relation\" [(ngModel)]=\"record.relationType\"> <option *ngFor=\"let option of logicTypes \" [value]=\"option.key \">{{option.name}}</option> </select> </div> </td> <td> <div *ngIf=\"getConditionType(record)==0\"> <span *ngIf=\"!record.condition.isBitwiseIndex\">{{record.condition.variableName}}</span> <span *ngIf=\"record.condition.isBitwiseIndex\">{{record.condition.variableName}} . {{record.condition.bitIndex}}</span> <span>=</span> <span>{{bitConditionTypeOptionService.getOptionNameByKey(record.condition.bitConditionLogic)}}</span> </div> <div *ngIf=\"getConditionType(record)==1\"> <span>{{record.condition.variableName}}</span> <span>{{comparatorTypeOptionService.getOptionNameByKey(record.condition.baseVariableValue.operator)}}</span> <span *ngIf=\"record.condition.baseVariableValue.valueType==1\">{{record.condition.baseVariableValue.variableName}}</span> <span *ngIf=\"record.condition.baseVariableValue.valueType==0\">{{record.condition.baseVariableValue.constValue}}</span> <span *ngIf=\"record.condition.realtionVariableValue\">{{relationTypeOptionService.getOptionNameByKey(record.condition.relationType)}}</span> <span *ngIf=\"record.condition.realtionVariableValue\">{{record.condition.variableName}}</span> <span *ngIf=\"record.condition.realtionVariableValue\">{{comparatorTypeOptionService.getOptionNameByKey(record.condition.realtionVariableValue?.operator)}}</span> <span *ngIf=\"record.condition.realtionVariableValue?.valueType==1\">{{record.condition.realtionVariableValue?.variableName}}</span> <span *ngIf=\"record.condition.realtionVariableValue?.valueType==0\">{{record.condition.realtionVariableValue?.constValue}}</span> </div> </td> </tr> </ng-template> </p-table> <div class=\"primeng-no-data\" *ngIf=\"!conditionItems.length\"> {{l('NoData')}} </div> </div> </div> <div class=\"btns\"> <button (click)=\"onAdd()\" type=\"button\" class=\"fe-btn fe-btn-small fe-btn-operate\">{{lc('AddNew')}}</button> <button (click)=\"onModify()\" type=\"button\" class=\"fe-btn fe-btn-small fe-btn-operate\">{{lc('Modify')}}</button> <button (click)=\"onDelete()\" type=\"button\" class=\"fe-btn fe-btn-small fe-btn-operate\">{{lc('Delete')}}</button> </div>"
        }),
        __param(4, Inject(VARIABLE_SERVICE))
    ], ConditionalControlComponent);
    return ConditionalControlComponent;
}(ResizableElementSettingModal));
export { ConditionalControlComponent };
